/**
 * Format an ISO date string as "MMM YYYY" in UK locale.
 * Returns empty string for invalid or missing input — UI components decide
 * how to handle that, rather than us injecting fallback text.
 */
export function formatDate(iso: string | undefined | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-GB', { month: 'short', year: 'numeric' });
}
